import { navChannels } from "@/mocks/chigua";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-paper">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-peach blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-64 w-64 rounded-full bg-amber/20 blur-3xl" />

      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:py-20">
        {/* 文案侧 */}
        <div className="relative">
          <div className="inline-flex items-center gap-2 rounded-full border border-ember/20 bg-cream px-3 py-1.5 text-xs font-semibold text-ember">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-ember opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-ember" />
            </span>
            素材持续归档中 · 按传播节奏更新
          </div>

          <h1 className="mt-5 font-display-x text-4xl font-black leading-tight md:text-5xl">
            一网打尽
            <span className="text-ember">吃瓜素材</span>
            <br />
            快人一步跟上节奏
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/70 md:text-lg">
            98吃瓜把视频片段、截图合集、录屏流出、直播回放与动图表情包，按事件时间线
            统一归档。想快速取素材、跟传播节奏，来这里按主题顺着翻就够快。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#clips"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ember px-6 py-3.5 text-sm font-bold text-cream transition hover:bg-[#c74423]"
            >
              <i className="ri-play-circle-line text-lg" />
              浏览今日视频片段
            </a>
            <a
              href="#shots"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-sand bg-cream px-6 py-3.5 text-sm font-bold text-ink transition hover:bg-peach"
            >
              <i className="ri-archive-2-line text-lg" />
              查看截图合集
            </a>
          </div>

          {/* 快捷入口条 */}
          <div className="mt-9">
            <p className="text-xs font-semibold uppercase tracking-widest text-ink/40">按分区直达</p>
            <div className="mt-3 flex flex-wrap gap-2.5">
              {navChannels.map((c) => (
                <a
                  key={c.id}
                  href={`#${c.id}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-full bg-cream px-3.5 py-2 text-sm font-medium text-ink/80 ring-1 ring-sand/60 transition hover:-translate-y-0.5 hover:bg-peach hover:text-ember"
                >
                  <i className={`${c.icon} text-ember`} />
                  {c.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* 视觉侧：三张倾斜封面 */}
        <div className="relative hidden lg:block">
          <div className="grain relative h-[440px] w-full overflow-hidden rounded-3xl bg-sand">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20collage%20of%20floating%20phone%20screens%20with%20video%20players%2C%20screenshot%20strips%20and%20popcorn%2C%20warm%20amber%20and%20coral%20gradient%20background%2C%20layered%20paper%20cutouts%2C%20film%20grain%2C%20cinematic%20light%2C%20vibrant%20archive%20mood%2C%20no%20readable%20text%2C%20no%20identifiable%20faces&width=1400&height=900&seq=chigua-hero-main&orientation=landscape"
              alt="吃瓜素材专题合集视觉封面"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent" />
            <div className="absolute bottom-4 left-4 flex items-center gap-2 rounded-full bg-paper/85 px-3 py-1.5 text-xs font-bold text-ink backdrop-blur">
              <i className="ri-play-list-2-line text-ember" />
              98 条主题时间线
            </div>
          </div>

          {/* 浮层小卡 */}
          <div className="absolute -left-8 bottom-10 w-44 animate-floaty rounded-2xl bg-paper p-3 shadow-[0_10px_30px_-12px_rgba(232,82,47,0.35)] ring-1 ring-sand/70">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-peach text-ember">
                <i className="ri-download-cloud-2-line" />
              </span>
              <div>
                <p className="text-xs font-bold text-ink">今日已更新</p>
                <p className="text-[11px] text-ink/50">素材即时可取</p>
              </div>
            </div>
          </div>

          <div className="absolute -right-4 top-6 w-36 animate-tilt rounded-2xl bg-paper p-3 ring-1 ring-sand/70">
            <p className="text-xs font-bold text-ink">表情包上新</p>
            <p className="mt-0.5 text-[11px] text-ink/50">阴阳怪气系列 8 枚</p>
          </div>
        </div>
      </div>
    </section>
  );
}